module.exports = __webpack_public_path__ + "images/dice-icon-xmas-caffae8348ff25b619c2b01a347159fa.png";